export default __webpack_public_path__ + "static/media/listbuilder-clock-selected.ebd4de66.svg";